import clsx from 'clsx'
import desenrola from '../../../images/desenrola/desenrola1x.png'
import desenrolaWebp from '../../../images/desenrola/desenrola1x.webp'
import desenrola2x from '../../../images/desenrola/desenrola2x.png'
import desenrolaWebp2x from '../../../images/desenrola/desenrola2x.webp'
import { styles } from '../styles'
const jsxScope = `jsx-${styles.__hash}`

export const DesenrolaBrasilImage = () => (
  <div className={clsx(jsxScope, 'debt-negotiation-program-section__img')}>
    <picture>
      <source
        srcSet={`${desenrolaWebp} 1x, ${desenrolaWebp2x} 2x`}
        type="image/webp"
      />
      <img
        src={desenrola}
        srcSet={`${desenrola} 1x, ${desenrola2x} 2x`}
        width={232}
        height={330}
        alt=""
      />
    </picture>
  </div>
)
